import { parseErrors } from 'helpers/parseResponseErrors';
import { Toast } from 'helpers/toast';
import { getProducts } from 'queries';
import { useQuery } from '@tanstack/react-query';
import { JsonDataItem } from 'types';

type FilterParams = {
  customerType?: string;
  pricingCategory?: string;
  serviceType?: string;
  productIds?: string;
};

export function useProductList(
  customerId?: string | number,
  serviceId?: string | number,
  { customerType, pricingCategory, serviceType, productIds }: FilterParams = {},
) {
  const { data: products, isInitialLoading: isProductsLoading } = useQuery(
    ['products', { customerId, serviceId, customerType, pricingCategory, serviceType, productIds }] as const,
    ({ queryKey: [_, params] }) => getProducts(params),
    {
      onError: (error: JsonDataItem) => {
        Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
      },
    },
  );

  return [products, isProductsLoading] as const;
}
